import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { BillingService } from 'projects/admin/src/app/services/billing.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { PackageModel } from 'projects/core/src/lib/models/package.model';

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.scss']
})
export class BillingListComponent extends BaseList implements OnInit {

  public packages: Array<PackageModel> = [];

  protected rightLoad = 'admin.billing.list';
  protected rightNew = 'admin.billing.create';
  protected rightOpen = 'admin.billing.show';
  protected apiUrl = '/billing';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    public billing: BillingService,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.billing'));
    this.loading = true;
    this.api.getModels('billing').subscribe({
      next: (result: any) => {
        this.packages = result.data?.map((data: any) => {
          return new PackageModel().deserialize(data);
        }).sort((a: PackageModel, b: PackageModel) => {
          if (!a.activated_at) {
            return -1;
          }
          if (!b.activated_at) {
            return 1;
          }
          return a.activated_at.isBefore(b.activated_at) ? 1 : -1;
        });
      },
      error: (error: any) => {
      }
    }).add(() => {
      this.loading = false;
    });
  }

}
